import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";
import CreditMemo from "../../../classes/CreditMemo";
import Invoice from "../../../classes/Invoice";

export default {
  routes: [
    {
      name: "sale-view",
      path: "projects/:projectID/sales/:saleID/:section?",
      props: true,
      meta: {
        icon: "sale",
        title: (route) => route.params.saleID,
        windowTitle: (route) =>
          i18n.global.tc("Sale") +
          " " +
          route.params.projectID +
          route.params.saleID,
        crumbs: ["projects", "project-view"],
      },
      component: () => import("pages/employee/SaleView"),
    },
    {
      name: "qc",
      path: "projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/packing-slips/:packingSlipID/qc/:itemID?",
      props: true,
      meta: {
        icon: "quality_control",
        title: i18n.global.t("Quality Control"),
        windowTitle: (route) =>
          i18n.global.t("Quality Control") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "vendor" } },
        ],
      },
      component: () => import("pages/employee/QualityControl"),
    },
    {
      name: "loading-truck-delivery",
      path: "projects/:projectID/sales/:saleID/delivery/:deliveryID/loading",
      props: true,
      meta: {
        icon: "loading",
        title: i18n.global.t("Loading Truck"),
        windowTitle: (route) =>
          i18n.global.t("Loading Truck") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "vendor" } },
        ],
      },
      component: () => import("pages/employee/LoadingTruck"),
    },
    {
      name: "loading-truck-labor",
      path: "projects/:projectID/sales/:saleID/labor/:laborID/loading",
      props: true,
      meta: {
        icon: "loading",
        title: i18n.global.t("Loading Truck"),
        windowTitle: (route) =>
          i18n.global.t("Loading Truck") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "vendor" } },
        ],
      },
      component: () => import("pages/employee/LoadingTruck"),
    },
    {
      name: "delivery",
      path: "/projects/:projectID/sales/:saleID/deliveries/:deliveryID/:dialog?",
      props: true,
      meta: {
        icon: "delivery",
        title: i18n.global.tc("Delivery"),
        windowTitle: (route) =>
          i18n.global.tc("Delivery") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "items" } },
        ],
      },
      component: () => import("pages/employee/Delivery"),
    },
    {
      name: "pickup",
      path: "/projects/:projectID/sales/:saleID/pickups/:pickupID/:dialog?",
      props: true,
      meta: {
        icon: "pickup",
        title: i18n.global.tc("Customer Pick-Up"),
        windowTitle: (route) =>
          i18n.global.tc("Customer Pick-Up") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "items" } },
        ],
      },
      component: () => import("pages/employee/Pickup"),
    },
    {
      name: "sale-labor",
      path: "/projects/:projectID/sales/:saleID/labor/:laborID/:dialog?",
      props: true,
      meta: {
        icon: "installation",
        title: i18n.global.tc("Installation"),
        windowTitle: (route) =>
          i18n.global.tc("Installation") +
          " – " +
          route.params.projectID +
          route.params.saleID,
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "labor" } },
        ],
      },
      component: () => import("pages/employee/SaleLabor"),
    },
    {
      name: "invoice-send",
      path: "/projects/:projectID/sales/:saleID/accounting/invoices/:invoiceID/send",
      props: true,
      meta: {
        icon: "send",
        title: i18n.global.t("Send Invoice"),
        crumbs: [
          "projects",
          "project-view",
          { name: "sale-view", params: { section: "accounting" } },
          { name: "invoice-view", isDialog: true },
        ],
      },
      component: () => import("pages/employee/InvoiceSend"),
    },
  ],

  dialogs: [
    // Reassign
    {
      name: "sale-reassign",
      path: "/projects/:projectID/sales/:saleID/reassign",
      component: () => import("../../../dialogs/employee/SaleReassign"),
    },

    // Cancel
    {
      name: "sale-cancel",
      path: "/projects/:projectID/sales/:saleID/cancel",
      meta: {
        color: "negative",
        textColor: "grey-1",
      },
      component: () => import("../../../dialogs/employee/SaleCancel"),
    },

    // Files tab uploads
    {
      name: "sale-files-upload",
      path: "/projects/:projectID/sales/:saleID/files/upload",
      component: () => import("../../../dialogs/employee/ProjectFilesUpload"),
    },

    // Orders
    {
      name: "order-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/new/:issueID",
      component: () => import("../../../dialogs/employee/OrderEdit"),
    },
    {
      name: "order-edit",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/edit",
      component: () => import("../../../dialogs/employee/OrderEdit"),
    },
    {
      name: "order-view",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/view",
      meta: {
        icon: "order",
        title: i18n.global.tc("Order"),
      },
      component: () => import("../../../dialogs/employee/OrderView"),
    },

    // Acks
    {
      name: "ack-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/acks/new",
      component: () => import("../../../dialogs/employee/AckEdit"),
    },
    {
      name: "ack-edit",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/acks/:ackID/edit",
      component: () => import("../../../dialogs/employee/AckEdit"),
    },
    {
      name: "ack-view",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/acks/:ackID/view",
      meta: {
        icon: "ack",
        title: i18n.global.tc("Acknowledgement"),
      },
      component: () => import("../../../dialogs/employee/AckView"),
    },
    {
      name: "ack-review",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/acks/:ackID/review",
      component: () => import("../../../dialogs/employee/AckReview"),
    },

    // Bills
    {
      // NOTE: `route-matcher` (used by the dialog router in boot/dialogs.js)
      // does not support the `:param?` optional syntax — a `?` gets left in
      // the path literally. Param capture uses `([^/]*)` which already
      // matches empty strings, so `ackID` is optional in practice when
      // omitted from the push params.
      name: "bill-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/bills/new/:ackID",
      component: () => import("../../../dialogs/employee/BillEdit"),
    },
    {
      // Vendor credit memos reuse the BillEdit dialog but carry their
      // "credit" intent in the URL so it survives hash-based routing.
      name: "vendor-credit-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/vendor-credits/new/:ackID",
      component: () => import("../../../dialogs/employee/BillEdit"),
    },
    {
      name: "bill-edit",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/bills/:billID/edit",
      component: () => import("../../../dialogs/employee/BillEdit"),
    },
    {
      name: "bill-view",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/bills/:billID/view",
      meta: {
        icon: "bill",
        title: i18n.global.tc("Bill"),
      },
      component: () => import("../../../dialogs/employee/BillView"),
    },

    // Packing Slips
    {
      name: "packing-slip-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/packing-slips/new/:ackID",
      component: () => import("../../../dialogs/employee/PackingSlipEdit"),
    },
    {
      name: "packing-slip-edit",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/packing-slips/:packingSlipID/edit",
      component: () => import("../../../dialogs/employee/PackingSlipEdit"),
    },
    {
      name: "packing-slip-view",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/packing-slips/:packingSlipID/view",
      meta: {
        icon: "packing-slip",
        title: i18n.global.tc("Packing Slip"),
      },
      component: () => import("../../../dialogs/employee/PackingSlipView"),
    },

    // Issues
    {
      name: "issue-packing-slip-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/issues/new/:orderID/:packingSlipID",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-order-item-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/orders/:orderID/packing-slips/:packingSlipID/qc/:itemID/issue",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-item-new",
      path: "/projects/:projectID/sales/:saleID/vendor/:vendor/items/:itemID/issue/:zone",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-labor-new",
      path: "/projects/:projectID/sales/:saleID/labor/:laborID/issue/new",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-sale-new",
      path: "/projects/:projectID/sales/:saleID/issue/new",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-edit",
      path: "/projects/:projectID/sales/:saleID/issues/:issueID/edit",
      component: () => import("../../../dialogs/employee/IssueEdit"),
    },
    {
      name: "issue-view",
      path: "/projects/:projectID/sales/:saleID/issues/:issueID/view",
      meta: {
        icon: "issue",
        title: i18n.global.tc("Sale Issue"),
      },
      component: () => import("../../../dialogs/employee/IssueView"),
    },

    // Items
    {
      name: "sale-item-new",
      path: "/projects/:projectID/sales/:saleID/items/new",
      meta: {
        icon: "window",
        title: i18n.global.tc("Item"),
      },
      component: () => import("../../../dialogs/employee/SaleItemEdit"),
    },
    {
      name: "sale-item-accessory-new",
      path: "/projects/:projectID/sales/:saleID/items/new/:parentItemID",
      meta: {
        icon: "window",
        title: i18n.global.tc("Item"),
      },
      component: () => import("../../../dialogs/employee/SaleItemEdit"),
    },
    {
      name: "sale-item-edit",
      path: "/projects/:projectID/sales/:saleID/items/:itemID/edit",
      meta: {
        icon: "window",
        title: i18n.global.tc("Item"),
      },
      component: () => import("../../../dialogs/employee/SaleItemEdit"),
    },
    {
      name: "sale-item-view",
      path: "/projects/:projectID/sales/:saleID/items/:itemID/view/:zone",
      meta: {
        icon: "window",
        title: i18n.global.tc("Item"),
      },
      component: () => import("../../../dialogs/employee/SaleItemView"),
    },
    {
      name: "sale-item-relocate",
      path: "/projects/:projectID/sales/:saleID/items/:itemID/relocate",
      component: () => import("../../../dialogs/employee/RelocateItem"),
    },

    // Delivery
    {
      name: "delivery-unload",
      path: "/events/:deliveryID/delivery/unload",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/TruckUnload"),
    },
    {
      name: "field-payment",
      path: "/projects/:projectID/sales/:saleID/field-payment",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/FieldPayment"),
    },

    // Labor
    {
      name: "sale-labor-unload",
      path: "/projects/:projectID/sales/:saleID/labor/:laborID/unload",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/TruckUnload"),
    },

    // Invoices
    {
      name: "invoice-new",
      path: "/projects/:projectID/sales/:saleID/accounting/invoices/new",
      meta: { auth: () => Invoice.canBeCreatedBy(store.state.main.user) },
      component: () => import("../../../dialogs/employee/InvoiceEdit"),
    },
    {
      name: "invoice-edit",
      path: "/projects/:projectID/sales/:saleID/accounting/invoices/:invoiceID/edit",
      meta: { auth: () => Invoice.canBeCreatedBy(store.state.main.user) },
      component: () => import("../../../dialogs/employee/InvoiceEdit"),
    },
    {
      name: "invoice-view",
      path: "/projects/:projectID/sales/:saleID/accounting/invoices/:invoiceID/view",
      meta: {
        auth: () => Invoice.canBeViewedBy(store.state.main.user),
        icon: "invoice",
        title: i18n.global.tc("Invoice"),
      },
      component: () => import("../../../dialogs/employee/InvoiceView"),
    },

    // Credit Memos
    {
      name: "credit-memo-new",
      path: "/projects/:projectID/sales/:saleID/accounting/credit-memos/new",
      meta: {
        auth: () => CreditMemo.canBeCreatedBy(store.state.main.user),
      },
      component: () => import("../../../dialogs/employee/CreditMemoEdit"),
    },
    {
      name: "credit-memo-edit",
      path: "/projects/:projectID/sales/:saleID/accounting/credit-memos/:creditMemoID/edit",
      meta: {
        auth: () => CreditMemo.canBeCreatedBy(store.state.main.user),
      },
      component: () => import("../../../dialogs/employee/CreditMemoEdit"),
    },
    {
      name: "credit-memo-view",
      path: "/projects/:projectID/sales/:saleID/accounting/credit-memos/:creditMemoID/view",
      meta: {
        auth: () => CreditMemo.canBeViewedBy(store.state.main.user),
        icon: "credit_memo",
        title: i18n.global.t("Credit Memo"),
      },
      component: () => import("../../../dialogs/employee/CreditMemoView"),
    },
  ],
};
